import React from "react";
import ReactDOM from "react-dom";
import ErrorBoundary from "@honeybadger-io/react";
import { QueryClient, QueryClientProvider } from "react-query";
import { LanguageProvider, useLanguage } from "./contexts/LanguageContext";
import { BrowserRouter as Router } from "react-router-dom";

import "./index.css";

import honeybadger from "./honeybadger";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";

const NON_RETRYABLE_STATUSES = new Set([400, 401, 403, 404, 422]);

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: (failureCount, error) => {
                if (NON_RETRYABLE_STATUSES.has(error?.status)) return false;
                return failureCount < 2;
            },
            refetchOnWindowFocus: false,
        },
        mutations: {
            retry: false,
        },
    },
});

const rootElement = document.getElementById("root");
if (!rootElement.innerHTML) {
  ReactDOM.render(
    <ErrorBoundary honeybadger={honeybadger}>
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <Router>
              <LanguageProvider>
                <App />
              </LanguageProvider>
            </Router>
          </AuthProvider>
        </QueryClientProvider>
      </React.StrictMode>
    </ErrorBoundary>,
    rootElement
  );
}
